/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Grid, Table, Input } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Loading from '../Loading/component';


function VMPaymentOptionsComponent({
  loading,
  total,
  showVmPaymentMappingList,
  onChangeSearchNameInput,
  onChangeSearchIdInput
}) {
  if (loading) {
    return (
      <Loading loading={loading} />
    );
  }
  return (
    <Grid centered padded style={{ paddingTop: '8vh', paddingBottom: '12vh' }}>
      <Helmet>
        <title> VM Payment List </title>
      </Helmet>
      <Grid.Row centered>
        <Grid.Column width={4}>
          <h2
            style={{
              fontWeight: 400,
              border: '1px solid #555',
              textAlign: 'center',
              color: '#555',
              padding: '0.5em'
            }}
          >
            VM Payment List
          </h2>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row centered>
        <Grid.Column width={4}>
          <Input
            label="Search Name"
            placeholder="Search using name..."
            onChange={onChangeSearchNameInput}
          />
        </Grid.Column>
        <Grid.Column width={4}>
          <Input
            label="Search Id"
            placeholder="Search using id..."
            onChange={onChangeSearchIdInput}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row centered>
        <Grid.Column width={14} >
          <Table celled fixed >
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell> Id</Table.HeaderCell>
                <Table.HeaderCell> Name</Table.HeaderCell>
                <Table.HeaderCell> Street</Table.HeaderCell>
                <Table.HeaderCell> City</Table.HeaderCell>
                <Table.HeaderCell> State</Table.HeaderCell>
                <Table.HeaderCell>Corporate name</Table.HeaderCell>
                <Table.HeaderCell>Payment Options</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {
                    showVmPaymentMappingList.map(vm => (
                      <Table.Row>
                        <Table.Cell>
                          {vm.vm_id}
                        </Table.Cell>
                        <Table.Cell>
                          <Link
                            to={`/vendingmachines/${vm.vm_id}/details`}
                            style={{
                            textDecoration: 'underline',
                            color: '#603cba',
                            wordWrap: 'break-word'
                          }}
                          >
                            {vm.name}
                          </Link>
                        </Table.Cell>
                        <Table.Cell>
                          {vm.street}
                        </Table.Cell>
                        <Table.Cell>
                          {vm.city}
                        </Table.Cell>
                        <Table.Cell>
                          {vm.state}
                        </Table.Cell>
                        <Table.Cell>
                          {vm.corporate_name}
                        </Table.Cell>
                        <Table.Cell >
                          {
                              vm.payment_options.map(option => (
                                <Table.Row >
                                  <Table.Cell>
                                    {option}
                                  </Table.Cell>
                                </Table.Row>
                              ))
                          }
                        </Table.Cell>

                      </Table.Row>
                    ))
                }
            </Table.Body>
          </Table>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}
export default VMPaymentOptionsComponent;



// WEBPACK FOOTER //
// ./src/Modules/VMPaymentList/component.jsx